import { render, staticRenderFns } from "./ContractDraftModal.vue?vue&type=template&id=24ed10b2&scoped=true&"
import script from "./ContractDraftModal.vue?vue&type=script&lang=js&"
export * from "./ContractDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./ContractDraftModal.vue?vue&type=style&index=0&id=24ed10b2&prod&scoped=true&lang=css&"
import style1 from "./ContractDraftModal.vue?vue&type=style&index=1&id=24ed10b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed10b2",
  null
  
)

export default component.exports